// Crear un nuevo archivo de configuración para URLs de API
const API_URL = process.env.REACT_APP_API_URL || "http://localhost:4000";
console.log("API Config - URL base:", API_URL);

// Exportar la configuración para su uso en toda la aplicación
export default {
  base: API_URL,
  endpoints: {
    movies: `${API_URL}/api/v1/movies`,
    animes: `${API_URL}/api/v1/animes`,
    series: `${API_URL}/api/v1/series`,
    users: `${API_URL}/api/v1/users`,
    seasons: `${API_URL}/api/v1/seasons`,
    episodes: `${API_URL}/api/v1/episodes`,
  }
};
